import BusinessRuleGroupsService from 'services/configuration/BusinessRuleGroupsService';
import { mapActions } from 'vuex';

export default {
  include: {
    ...mapActions([
      'loadRecipients',
      'loadQueroPagoRecipient',
    ]),
    initializeTooltips() {
      $(() => {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    changeModalVisibility(modalName, open) {
      this[modalName] = open;
    },
    updateMainForm(form, changes) {
      form.addValues(changes);

      Object.keys(changes).forEach((field) => {
        form.get(field).validateField();
      });
    },
    createAdvancedPaymentDiscount($event) {
      this.advancedPaymentDiscountRules.create.push($event);
      this.changeModalVisibility('showAdvancedPaymentDiscountModal', false);
    },
    disableAdvancedPaymentDiscountRule(index) {
      if (this.advancedPaymentDiscountRules.create[index].id) {
        this.advancedPaymentDiscountRules.disable.push(
          this.advancedPaymentDiscountRules.create[index],
        );
      }
      this.advancedPaymentDiscountRules.create.splice(index, 1);
    },
    formatAmountType(type, value) {
      let formatValue;

      if (type == null) {
        formatValue = '';
      } else if (type === 'percentage') {
        formatValue = this.$options.filters.formatPercentage(value);
      } else if (type === 'absolute') {
        formatValue = this.$options.filters.formatCurrency(value);
      }
      return formatValue;
    },
    setSelectedRecipient(recipient) {
      this.splitRule.addValues({ recipientId: recipient.id });
      this.recipient = recipient;
    },
    loadBusinessRuleGroup() {
      this.businessRuleGroup.addValues({
        ...this.rule,
        campusId: this.rule.campus?.id,
        courseId: this.rule.course?.id,
        levelId: this.rule.level?.id,
        kindId: this.rule.kind?.id,
        shiftId: this.rule.shift?.id,
      });
    },
    loadSplitRules() {
      const enabledSplitRule = this.rule.enabledSplitRules.find(
        el => el.recipient.document !== this.queroPagoRecipient.document,
      );
      const qpSplitRule = this.rule.enabledSplitRules.find(
        el => el.recipient.document === this.queroPagoRecipient.document,
      );

      this.splitRule.addValues({
        recipientId: enabledSplitRule.recipient.id,
        percentage: enabledSplitRule.percentage,
      });
      this.recipient = enabledSplitRule.recipient;

      this.queropagoSplitRule.addValues({ percentage: qpSplitRule.percentage });
    },
    loadDueDayRule() {
      this.dueDayRule.addValues({
        ...this.rule.dueDayRule,
        dueDays: this.rule.dueDayRule.dueDays.join(', '),
      });
    },
    loadPaymentMethodsRules() {
      this.paymentMethodRules.addValues({
        methods: this.rule.paymentMethodRules.map(el => el.paymentMethod),
      });
    },
    loadContractDischargeRules() {
      this.contractDischargeRules.addValues({
        methods: this.rule.contractDischargeRules.map(el => el.paymentMethod),
      });
    },
    loadContractCreationRule() {
      this.contractCreationRule.addValues({ ...this.rule.contractCreationRule });
    },
    loadChargesRule() {
      this.chargesRule.addValues({ ...this.rule.chargesRule });
      switch (this.rule.chargesRule?.applyCharges) {
        case true:
          this.chargesRule.addValues({ type: 'custom' });
          break;
        case false:
          this.chargesRule.addValues({ type: 'disabled' });
          break;
        default:
          this.chargesRule.addValues({ type: 'default' });
          break;
      }
    },
    loadQbIntegrationRule() {
      this.qbIntegrationRule.addValues({ ...this.rule.qbIntegrationRule });
    },
    loadAdmissionPaymentRule() {
      this.admissionPaymentRule.addValues({ ...this.rule.admissionPaymentRule });
    },
    loadBillAdjustmentRule(form, billAdjustment) {
      form.addValues({ ...billAdjustment });

      if (billAdjustment?.thresholdType === 'absolute') {
        form.addValues({
          thresholdValue: billAdjustment.treatedThresholdValue,
        });
      }
    },
    loadAdvancedDiscountPaymentRule() {
      this.advancedPaymentDiscountRules.create.push(...this.rule.enabledAdvancedPaymentDiscountRules);
    },
    validateBusinessRuleGroup() {
      this.businessRuleGroup.validateForm();
      this.splitRule.validateForm();
      this.queropagoSplitRule.validateForm();
      this.dueDayRule.validateForm();
      this.paymentMethodRules.validateForm();
      this.contractDischargeRules.validateForm();
      this.contractCreationRule.validateForm();
      this.chargesRule.validateForm();
      this.qbIntegrationRule.validateForm();
      this.admissionPaymentRule.validateForm();
      this.underpaymentRule.validateForm();
      this.overpaymentRule.validateForm();
    },
    processRequest(request, successMessage, errorPrefixMessage) {
      this.$loader.show();

      request
        .then(() => {
          this.$alert.notifySuccess(successMessage);
          this.$emit('edit-business-rule-group', false);
        })
        .catch(({ response: { data } }) => {
          this.$alert.notifyAlert(`${errorPrefixMessage}: ${data.message}`);
        })
        .finally(() => { this.$loader.hide(); });
    },
    createOrUpdate() {
      this.validateBusinessRuleGroup();
      if (this.isValidBusinessRuleGroup) {
        if (this.isEditOperation) {
          this.processRequest(
            BusinessRuleGroupsService.update(this.bussinessRuleGroupGetRawValue),
            'Regra de Negócio atualizada com sucesso',
            'Erro ao tentar atualizar a Regra de Negócio (BRG)',
          );
        } else {
          this.processRequest(
            BusinessRuleGroupsService.create(this.bussinessRuleGroupGetRawValue),
            'Regra de Negócio criada com sucesso',
            'Erro ao tentar criar uma nova Regra de Negócio (BRG)',
          );
        }
      }
    },
  },
};
